<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ih0j8c/tc-custom/9783988269478.jpg?1704453540973" alt="This image is the cover for the book Bagdad, Babylon, Ninive, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bagdad, Babylon, Ninive, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Bagdad, Babylon, Ninive ist ein Buch des schwedischen Entdeckers und Geografen Sven Anders Hedin. Das Buch bietet einen faszinierenden Einblick in Hedins Forschungsreisen und Erkundungen in Mesopotamien, einer historisch und kulturell reichen Region, die heute Teile des Irak und der umliegenden Länder umfasst. Während seiner Reisen in Mesopotamien beschreibt Hedin die antiken Städte Bagdad, Babylon und Ninive sowie andere historische Stätten und Denkmäler. Er berichtet von den Ausgrabungen, Entdeckungen und Erkenntnissen, die er in dieser Region gemacht hat, einschließlich seiner Begegnungen mit den Einheimischen und seiner Erforschung der Kultur und Geschichte. Hedin hebt die Bedeutung dieser historischen Stätten hervor, die einst bedeutende Zentren der alten Zivilisationen waren, darunter das babylonische Reich und das assyrische Reich. Er beschreibt die Ruinen, Monumente und archäologischen Schätze, die in dieser Region zu finden sind, und betont ihre Bedeutung für das Verständnis der Geschichte und Kultur des Nahen Ostens. "Bagdad, Babylon, Ninive" ist nicht nur ein Buch über die Erkundung von antiken Stätten, sondern auch ein Dokument der faszinierenden Geschichte und Kultur dieser Region. Es trägt dazu bei, das Wissen über die Vergangenheit des Nahen Ostens zu erweitern und ist ein wertvolles Werk für Historiker, Archäologen und alle, die sich für die Geschichte und Kultur des antiken Mesopotamiens interessieren.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sven Anders Hedin
      </h2>
      
      <p class="authorDescription body article">Sven Anders Hedin (1865-1952) war ein renommierter schwedischer Entdecker, Geograph, Topograf und Schriftsteller, der für seine bedeutenden Expeditionen und seine Erforschung Zentralasiens bekannt ist. Sven Anders Hedin wird für seine herausragenden Leistungen in der Geographie und Topografie, seine kartografische Arbeit und seine tiefgreifende Erforschung Zentralasiens geehrt. Seine Expeditionen und sein schriftstellerisches Werk haben einen nachhaltigen Einfluss auf die Erforschung dieser Region und auf die Geographie im Allgemeinen hinterlassen.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e058552